import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({ title: "Save Search Panel Config" })
export default class RefineTextPanelConfig {
	@Input({ type: InputType.TEXT, title: "Query Paramter" })
	public paramName: string;
}



// WEBPACK FOOTER //
// ./src/panels/saveSearch/SaveSearchPanelConfig.ts